<div class="info-bar">
    <div class="counters">
        <em>{{ totalCount }} Search Results</em> | Filters ({{
            appliedFiltersCount
        }})
    </div>
    <button class="done" (click)="activeModal.close()">Done</button>
</div>
<div class="wrapper">
    <div *ngIf="!!searchInfo">
        <app-facets
            [syncFacets]="true"
            [premiumCollectionSearch]="!!searchInfo"
        ></app-facets>
    </div>
    <div *ngIf="!searchInfo">
        <app-facets [syncFacets]="true"></app-facets>
    </div>
    <div class="see-all-wrapper">
        <button (click)="activeModal.close()">
            See All {{ totalCount }} Search Results
        </button>
    </div>
</div>
